<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="type === 'show' ? actions : []"
    :form="form"
    :title="title || $t('model.ticket')"
    resource="tickets"
    :onFetchData="onFetchData"
    :batch-actions="batchActions"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/tickets.js';
import _ from 'lodash';

@Component
export default class Tickets extends Vue {
  @Prop(String) type;
  @Prop(Number) ticketEventId;
  @Prop(String) title;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'serial_code_cont',
      {
        key: 'miapay_wallet_holder_phone_cont',
        label: `${this.$t('model.user')} ${this.$t('user.phone')}`
      },
      !this.ticketEventId && 'ticket_event_id_eq',
      'ticket_kind_id_eq',
      {
        key: 'ticket_order_number_cont',
        label: `${this.$t('model.ticketOrder')} ${this.$t('ticketOrder.number')}`,
      },
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'serial_code',
      {
        prop: 'user',
        label: this.$t('model.user'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'users.show', params: { id: value.id } }}>{value.phone}</bean-link>
          }
        }
      },
      !this.ticketEventId && 'ticket_event',
      'ticket_kind',
      'expire_at',
      'redeem_at',
      type === 'show' && {
        key: 'redeemer',
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'agents.show', params: { id: value.id } }}>{value.name || value.phone}</bean-link>
          }
        }
      },
      type === 'show' && {
        prop: 'ticket_order',
        label: this.$t('model.ticketOrder'),
        renderCell: (h, { props: { value } }) => {
          if (value) {
            return <bean-link keepNode to={{ name: 'ticket_orders.show', params: { id: value.id } }}>{value.number}</bean-link>
          }
        }
      },
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [

    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'tickets.edit', params: { id: row.id } }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'tickets.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }

  async onFetchData({ type }) {
    if (type === 'index') {
      const { data, pagination } = await this.$request.get('/tickets', { params: { ...this.$route.query, ticket_event_id_eq: this.ticketEventId } });
      return {
        data,
        pagination
      }
    }

    if (type === 'show' || type === 'edit') {
      const data = await this.$request.get(`/tickets/${this.$route.params.id}`);
      return { data };
    }

    if (type === 'new') {
      return {
        data: {}
      }
    }
  }

  batchActions({ selection }, { resource }) {
    const ticket_event_id_eq = this.ticketEventId;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, ticket_event_id_eq, timezone });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, ticket_event_id_eq, timezone, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    return [
      () => <el-button type='primary' onClick={() => exportClick(selection)}><i class='el-icon-download'></i> {this.$t('bean.actionExport')}</el-button>
    ];
  }
}

export const route = [
  {
    path: '/tickets',
    name: 'tickets.index',
    component: Tickets,
    props: {
      type: 'index',
    }
  },
  {
    path: '/tickets/new',
    name: 'tickets.new',
    component: Tickets,
    props: {
      type: 'new',
    }
  },
  {
    path: '/tickets/:id',
    name: 'tickets.show',
    component: Tickets,
    props: {
      type: 'show',
    }
  },
  {
    path: '/tickets/:id/edit',
    name: 'tickets.edit',
    component: Tickets,
    props: {
      type: 'edit'
    }
  }
]
</script>
